"use client";

import type { Champignons } from "@repo/types";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { imageService } from "../../../lib/services";
import { getChampignonImageFilename } from "../utils/champignon-image";

interface ChampignonImagePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imgUrl: NonNullable<Champignons["img_url"]>;
  title: string;
  subtitle?: string;
}

export function ChampignonImagePreviewDialog({
  open,
  onOpenChange,
  imgUrl,
  title,
  subtitle,
}: ChampignonImagePreviewDialogProps) {
  const filename = getChampignonImageFilename(imgUrl);
  const previewSrc = filename
    ? imageService.getOptimizedImageUrl(filename, "champignon", 1200, 900)
    : imageService.getPlaceholderUrl("champignon");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-0 overflow-hidden p-0 sm:max-w-2xl">
        <DialogHeader className="space-y-1 border-b border-border/60 px-6 py-5 text-left">
          <DialogTitle className="text-lg font-semibold tracking-tight">{title}</DialogTitle>
          {subtitle ? (
            <DialogDescription className="text-sm">{subtitle}</DialogDescription>
          ) : null}
        </DialogHeader>

        <div className="bg-gradient-to-br from-muted/50 via-background to-muted/30 px-6 py-6">
          <div className="overflow-hidden rounded-xl border border-border/60 bg-background/90 shadow-sm ring-1 ring-border/20">
            <img
              src={previewSrc}
              alt={title}
              className="mx-auto max-h-[min(70vh,520px)] w-full object-contain p-4"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
